import { Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { CardLegend, LegendComponentProps } from "./CardLegend";
import { Donut, DonutProps } from "./Donut";
import ModuleProgressBar, { ModuleProgressBarProps } from "./ModuleProgressBar";
import { FontRoboto } from "../../../../../styles/Theme";

interface LargeCardProps {
  body: string;
  donutProps: DonutProps;
  progressBarProps: ModuleProgressBarProps;
  legendProps: LegendComponentProps;
}

const useStyle = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    borderRadius: "1rem",
    width: "100%",
    height: "100%",
  },
  heading: {
    marginBottom: "1.5rem",
    color: "#191919",
  },
  headingText: {
    fontSize: "1.5rem !important",
    fontWeight: 500,
  },
  card: {
    display: "flex",
    backgroundColor: "#FFFFFF",
    height: "100%",
    color: "#484848",
    borderRadius: "1rem",
    padding: "2rem",
    flexDirection: "column",
    [theme.breakpoints.down("lg")]: {
      padding: "1rem",
    },
  },
  innerSection: {
    flexDirection: "row",
    alignItems: "center",
    display: "flex",
  },
  innerBody: {
    fontSize: "0.8750em",
    marginTop: "1rem !important",
    fontFamily: FontRoboto,
  },
  progressGroup: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "1.3rem",
    alignSelf: "center",
    flex: 1,
  },
}));

export const ProgressCardLarge = (props: LargeCardProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <div className={classes.card}>
        <Stack
          flexDirection="row"
          alignItems="center"
          sx={{ height: "100%", width: "100%" }}>
          <div className={classes.innerSection}>
            <Donut
              aria-label={props.donutProps["aria-label"]}
              centerValue={props.donutProps.centerValue}
              value={props.donutProps.value}
              secondaryValue={props.donutProps.secondaryValue}
              label={props.donutProps.label}
            />
            <Stack
              flexDirection="column"
              justifyContent="center"
              sx={{ marginLeft: "24px", height: "100%", width: "100%" }}>
              <p className={classes.innerBody}>{props.body}</p>
              <ModuleProgressBar {...props.progressBarProps} />
              <CardLegend legendProps={props.legendProps} />
            </Stack>
          </div>
        </Stack>
      </div>
    </div>
  );
};
